import { connect } from "react-redux";
import Component from "./OrdersPage";

export default connect(
    null,
    ({ scp: { checkSerials }, scp: { addStock }, alert: { silence } }) => ({ checkSerials, addStock, silence })
)(Component);
